<template>
  <form :action="action" method="POST" enctype="application/x-www-form-urlencoded" novalidate @submit.prevent="validate" >

    <md-progress-bar class="md-accent" md-mode="indeterminate" v-if="sending" ></md-progress-bar>

    <slot></slot>


    <md-snackbar :md-active.sync="submitSuccess">{{submitSuccess}}</md-snackbar>
  </form>
</template>
<script>
export default {
  name: 'BraveFormTemplate',
  props: ['submitSuccess', 'validate', 'sending', 'action']
}
</script>

<style lang="scss" scoped>
  form {
    position: relative;
  }

  .md-progress-bar {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 20;
  }

</style>


// WEBPACK FOOTER //
// lib/brave-form/components/brave-form.vue